export default {
  en: {
    title: 'If you\'re a coach...',
    subtitle: 'Please ask the club you coach with to add you into their team and you will see the link to their club here.',
  },
};
